import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const TradeDetail = (props) => {
    const [check, setcheck] = useState(false)
    const getdata = async () => {
        const sendData = {
            Value: Number(props.parametersId),
            UserId: Number(props.useridd)
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Checktrate', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setcheck(data)
                })


    };

    const handlechange = async (e) => {
        const sendData = {
            Value: Number(props.parametersId),
            UserId: Number(props.useridd),
            Apikey2: String(e.target.checked),
            CatgId: Number(47)
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Adddatrade', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === "Done") {
                        Swal.fire({
                            icon: "success",
                            title: "Done",
                            text: "Updated Successfully",
                            focusConfirm: false,
                        })
                        getdata()
                    }
                })

}

    useEffect(() => {
        getdata()
    }, [])
    return (
        <li>
            <div className="custom-control custom-checkbox custom-control-pro custom-control-pro-icon no-control checked">
                <input type="checkbox" checked={check} onChange={(e) => handlechange(e)} className="custom-control-input" id={"btnOnlyIconCheck" + String(props.index)} />
                <label style={{ padding: 20, fontSize: 18 }} className="custom-control-label" htmlFor={"btnOnlyIconCheck" + String(props.index)}>
                    {props.name}

                </label>
            </div>
        </li>
    );
};

export default TradeDetail;
